import { Add, Remove } from "@mui/icons-material";
import { MapButton, ZoomButtonsWrapper } from "./styles";
import { FC } from "react";

type Props = {
  setZoom: (value: any) => void;
};

export const ZoomButtons: FC<Props> = ({ setZoom }) => {
  return (
    <ZoomButtonsWrapper>
      <MapButton
        onClick={() => setZoom((prev: any) => prev - 1)}
        color="primary"
      >
        <Remove />
      </MapButton>
      <div
        style={{ width: "26px", height: "2px", background: "#E9ECEF" }}
      ></div>
      <MapButton
        onClick={() => setZoom((prev: any) => prev + 1)}
        color="primary"
      >
        <Add />
      </MapButton>
    </ZoomButtonsWrapper>
  );
};
